import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL_WAREHOUSE;

const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit= (type) => {
    return ({
        type: type 
    })
}

export const postSubCategory = (state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        console.log(state)
        const body ={
            name: state.name,
            description: state.description,
            material_category_id: state.category
        }
        axios.post(`${END_POINT}/api/material-sub-categories`, body, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_WAREHOUSE));
                dispatch(loadSubCategories());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
export const loadSubCategories = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/material-sub-categories`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_SUB_CATEGORIES));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}


export const deleteSubCategory = (id,setloadDel,setIsDeleted,setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/material-sub-categories/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_SUB_CATEGORY));
                notifysuccess(res.data.message)
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putSubCategory = (id,name,description,material_category_id,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        axios.put(`${END_POINT}/api/material-sub-categories/${id}`,
        {name,description,material_category_id}
        , {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_SUB_CATEGORY));
                dispatch(loadSubCategories());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}


export const filterSubCategory = (name,email,role, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (name !== '') queryParams.push(`filters[name]=${name}`);
        if (email !== '') queryParams.push(`filters[email]=${email}`);
        if (role !== '') queryParams.push(`filters[role]=${role}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/users?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            setLoad(false);
             dispatch(get(res.data.data,types.GET_SUB_CATEGORIES));
        }).catch((err) => {;
            setLoad(false);
        });
    };
};


